import {
  MotifButton,
  MotifFileUploader,
  MotifFileUploaderItem,
  MotifFormField,
  MotifIcon,
  MotifInput,
  MotifLabel,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifOption,
  MotifSelect
} from '@ey-xd/motif-react';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const WorkspaceVersionDocumentUpload = () => {
  const dispatch: any = useDispatch();
  const params = useParams();
  const { workspaceId } = params;
  const [open, setOpen] = React.useState(false);
  const [file, setFile] = useState<any>(undefined);
  const [version, setVersion] = useState<any>('');
  const { workspaces } = useSelector((state: any) => state);
  const { dialogDetails, inProgress } = useSelector((state: any) => state.workspaces);

  useEffect(() => {
    if (dialogDetails && dialogDetails.dialogType === 'UPLOAD_DOCUMENT_VERSION') {
      setOpen(true);
    }
  }, [dialogDetails]);
  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles);
  }, []);

  const toggleDialogOpen = () => {
    if (open === true) {
      dispatch({ type: 'CLOSE_WORKSPACE_DIALOG' });
    }
    setOpen(!open);
  };
  const handleConfirm = () => {
    dispatch({
      type: 'WORKSPACE_UPLOAD_VERSION_DOCUMENT',
      payload: {
        documentId: dialogDetails?.documentId,
        documentType: dialogDetails?.documentType,
        file: file[0],
        workspaceId
      }
    });
    toggleDialogOpen();
  };
  const renderFileSelect = useCallback(() => {
    return (
      <MotifFormField
        onChange={(event) => {
          setFile(event.target.files);
        }}
      >
        <MotifFileUploader onDrop={onDrop as any} label="Click to upload or drag and drop" reactive>
          <>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop some files here, or click to select files</p>
                </div>
              </section>
            )}
          </>
          {file !== undefined && (
            <MotifFileUploaderItem
              fileName={file[0]?.path}
              id={1}
              onRemove={() => {
                setFile(undefined);
              }}
              removable
            />
          )}
        </MotifFileUploader>
      </MotifFormField>
    );
  }, [file]);
  const inputChangeHandler = (event: any) => {
    setVersion(event.target.value);
  };
  return (
    <MotifModal onClose={toggleDialogOpen} show={open}>
      <MotifModalHeader>Upload new version to '{dialogDetails?.documentType}'</MotifModalHeader>
      <MotifModalBody>
        <div className="flex flex-col gap-3">
          {version && version !== '' && <h5>Document will be uploaded as {version}</h5>}
          <div></div>{' '}
          <div className="motif-row gap-y-5">
            {/* <div className="otif-col-1 motif-col-lg-12">
                              <MotifFormField
                                  aria-label="Input"
                                  role="group"
                              >
                                  <MotifLabel
                                      aria-label="Input"
                                      for="input"
                                  >
                                      Version
                                  </MotifLabel>
                                  <MotifInput
                                      aria-label="Input"
                                      ariaLabel="Input"
                                      id="input"
                                      label="Input"
                                      onChange={inputChangeHandler}
                                      value={version}
                                  />
                              </MotifFormField>
                          </div> */}
            <div className="otif-col-1 motif-col-lg-12">{renderFileSelect()}</div>
          </div>
        </div>
      </MotifModalBody>
      <MotifModalFooter style={{ borderTop: '1px solid #ffffff26' }} className="!pb-0">
        <div className="flex gap-3 justify-end items-center my-4">
          <MotifButton onClick={toggleDialogOpen} size="medium" type="button" variant="secondary">
            Cancel
          </MotifButton>
          <MotifButton
            disabled={file === undefined}
            className="!mt-0"
            onClick={handleConfirm}
            size="medium"
            type="button"
          >
            Confirm
          </MotifButton>
        </div>
      </MotifModalFooter>
    </MotifModal>
  );
};

export default WorkspaceVersionDocumentUpload;
